export default [
    {
        path: '/dashboard/annual',

        name: 'memberDashboard.memberships.upsellAnnual',

        components: {
            header: () => import('@/views/memberDashboard/header/index.vue'),
            default: () => import('@/modules/member/membership/views/MembershipChangeUpsell.vue'),
            footer: () => import('@/views/public/footer/index.vue'),
        },

        meta: {
            middleware: {
                mustBeAuthenticated: true,
                mustHasRoles: ['member']
            }
        }
    },
    {
        path: '/dashboard/annual/confirmation',

        name: 'memberDashboard.memberships.upsellAnnual.confirmation',

        components: {
            header: () => import('@/views/memberDashboard/header/index.vue'),
            default: () => import('@/modules/member/membership/views/MembershipChangeUpsellConfirmation.vue'),
            footer: () => import('@/views/public/footer/index.vue'),
        },

        meta: {
            middleware: {
                mustBeAuthenticated: true,
                mustHasRoles: ['member']
            }
        }
    },
]